import * as moment from 'moment-timezone';

export class IanaTimezoneHelper {
  static getBrowserTimezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  static getTimeZoneDisplayList(includeIdentifier?: string): IanaTimeZoneDisplay[] {
    const popularIdentifiers = [
      'Pacific/Pago_Pago',
      'Pacific/Honolulu',
      'America/Anchorage',
      'America/Los_Angeles',
      'America/Vancouver',
      'America/Denver',
      'America/Edmonton',
      'America/Chicago',
      'America/Winnipeg',
      'America/Mexico_City',
      'America/New_York',
      'America/Toronto',
      'America/Bogota',
      'America/Lima',
      'America/Caracas',
      'America/Halifax',
      'America/Santiago',
      'America/Sao_Paulo',
      'America/Argentina/Buenos_Aires',
      'Atlantic/Cape_Verde',
      'Atlantic/Reykjavik',
      'UTC',
      'Europe/London',
      'Europe/Dublin',
      'Europe/Lisbon',
      'Europe/Brussels',
      'Europe/Amsterdam',
      'Europe/Berlin',
      'Europe/Paris',
      'Europe/Madrid',
      'Europe/Rome',
      'Europe/Zurich',
      'Europe/Vienna',
      'Europe/Warsaw',
      'Europe/Prague',
      'Europe/Stockholm',
      'Europe/Oslo',
      'Europe/Copenhagen',
      'Europe/Helsinki',
      'Europe/Bucharest',
      'Europe/Athens',
      'Europe/Istanbul',
      'Europe/Moscow',
      'Africa/Lagos',
      'Africa/Cairo',
      'Africa/Johannesburg',
      'Africa/Nairobi',
      'Asia/Jerusalem',
      'Asia/Riyadh',
      'Asia/Dubai',
      'Asia/Karachi',
      'Asia/Kolkata',
      'Asia/Dhaka',
      'Asia/Bangkok',
      'Asia/Jakarta',
      'Asia/Shanghai',
      'Asia/Hong_Kong',
      'Asia/Singapore',
      'Asia/Kuala_Lumpur',
      'Asia/Tokyo',
      'Asia/Seoul',
      'Australia/Perth',
      'Australia/Adelaide',
      'Australia/Sydney',
      'Australia/Melbourne',
      'Australia/Brisbane',
      'Pacific/Guadalcanal',
      'Pacific/Auckland',
    ];

    if (includeIdentifier && !popularIdentifiers.includes(includeIdentifier) && moment.tz.zone(includeIdentifier)) {
      popularIdentifiers.push(includeIdentifier);
    }

    return popularIdentifiers.map((identifier) => this.createTimeZoneDisplay(identifier));
  }

  static getTimezoneDisplayMap(includeIdentifier?: string): IanaTimeZoneMap {
    const timezoneList = this.getTimeZoneDisplayList(includeIdentifier);
    const map: IanaTimeZoneMap = {};
    timezoneList.forEach((item) => {
      map[item.value] = item.title;
    });
    return map;
  }

  static createTimeZoneDisplay(identifier: string): IanaTimeZoneDisplay {
    const zone = moment.tz(identifier);
    const offsetMinutes = zone.utcOffset();
    const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
    const offsetMins = Math.abs(offsetMinutes) % 60;
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const offsetString = `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMins).padStart(2, '0')}`;
    const locationParts = identifier.split('/');
    const locationName = locationParts[locationParts.length - 1].replace(/_/g, ' ');

    return {
      title: `${identifier.replace(/_/g, ' ')} (UTC${offsetString})`,
      value: identifier,
      offset: offsetString,
      region: locationParts[0],
    };
  }
}

export interface IanaTimeZoneDisplay {
  title: string;
  value: string;
  offset: string;
  region: string;
}

export interface IanaTimeZoneMap {
  [ianaIdentifier: string]: string;
}
